module.exports = __webpack_public_path__ + "img/landing-3.64f0dfdc.png";